import React from 'react'
import TableOrdenes from './TableOrdenes'

const OrdenesRegistradas = () => {

  return (
    <div >
      <TableOrdenes />
    </div>
  )
}

export default OrdenesRegistradas